import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import './Achievements.scss';
import { achievementsData } from "./achievementsData";
import Typography from '@mui/material/Typography';

const Achievements = () => {

    React.useEffect(() => {
        AOS.init();
        AOS.refresh();
    }, []);

    return (
        <div className="achievements">

            <Typography variant="h4" gutterBottom component="div" className="text-center">
                Achievements 
            </Typography>

            <div className="notes">
                <ul>

                {
                    achievementsData.map((achievement, index) => (
                        <div 
                            key={index}
                            data-aos="zoom-out" 
                            data-aos-delay={150*(index+1)}
                            data-aos-duration="900"
                            data-aos-easing="ease-in-out"
                        >
                            <li className={achievement.class}>
                                <div dangerouslySetInnerHTML={{__html:achievement.content}}></div>
                                {/* <p>{achievement.content}</p> */}
                            </li>
                        </div>
                    ))
                }
                </ul>
            </div>
        </div>
    );
}

export default Achievements;